import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  IonLabel,
  IonList,
  IonItem,
  IonButton,
  IonModal,
  IonContent,
  IonFooter,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';

export enum LabelConfigurationWarningMode {
  NONE = 0,
  NEW = 2,
  NEED_UPDATE = 1,
}

@Component({
  selector: 'app-label-configuration',
  templateUrl: './label-configuration.component.html',
  styleUrls: ['./label-configuration.component.scss'],
  standalone: true,
  imports: [
    IonLabel,
    IonList,
    IonItem,
    IonButton,
    IonModal,
    IonContent,
    IonFooter,
    TranslatePipe,
    GlobalPageHeaderComponent,
  ],
})
export class LabelConfigurationComponent implements OnInit {
  @Input() title?: string;
  @Input() titleListe: string = '';
  @Input() value: number = 0;
  @Input() liste: any[] = [];
  @Input() namedList: any[] = [];
  @Input() description?: string;
  @Input() information?: () => void;
  @Input() warningMode?: LabelConfigurationWarningMode =
    LabelConfigurationWarningMode.NONE;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<any>();

  isModalOpen = false;
  selectedValue: any = null;

  constructor() {}

  ngOnInit() {
    if (this.namedList.length == 0) {
      this.selectedValue = this.value;
    }
  }

  openModal() {
    this.isModalOpen = true;

    if (this.namedList.length == 0) {
      this.selectedValue = this.value;
    }
  }

  closeModal() {
    this.isModalOpen = false;
  }

  selectItem(itemRef: number) {
    this.selectedValue = itemRef;
  }

  confirmSelection() {
    if (this.namedList.length > 0) {
      console.log(this.selectedValue);
      console.log(this.liste.find((item) => item.ref === this.selectedValue));

      this.onPress.emit(
        this.liste.find((item) => item.ref === this.selectedValue).value ?? 0,
      );
    } else {
      this.onPress.emit(this.selectedValue);
    }

    this.isModalOpen = false;
  }

  callInformation() {
    if (this.information) {
      this.information();
    }
  }

  getSelectedLabel(): string {
    if (this.namedList.length > 0)
      return (
        this.namedList.find((item) => item.ref === this.value)?.label ?? ''
      );

    const selectedItem = this.liste.find((item) => item.ref === this.value);
    return selectedItem ? selectedItem.label : '';
  }

  protected readonly LabelConfigurationWarningMode =
    LabelConfigurationWarningMode;
}
